webpackJsonp([25935538600222],{

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _radium = __webpack_require__(10);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _components = __webpack_require__(26);
	
	var _SectionTitle = __webpack_require__(53);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SchedulePage = function SchedulePage() {
		return _react2.default.createElement(
			_components.PageBox,
			null,
			_react2.default.createElement(
				_SectionTitle2.default,
				null,
				"Schedule"
			),
			_react2.default.createElement("br", null),
			_react2.default.createElement("iframe", { src: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&src=m22u4pqpsor7g1q2rdr68hdvd0%40group.calendar.google.com&color=%23333333&ctz=Asia%2FManila", style: "border:solid 1px #777", width: "100%", height: "600", frameborder: "0", scrolling: "no" })
		);
	};
	
	exports.default = (0, _radium2.default)(SchedulePage);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-calendar-js-55550913d5df11e67e97.js